import React from 'react';
import SMCalendarBaloonBaseView from './SMCalendarBaloonBaseView';
import SMRoomUnavailabilityResource from 'resources/SMRoomUnavailabilityResource';

class SMORoomUnavailabilityCalendarBaloon extends SMCalendarBaloonBaseView {
  
  handleClickSaveButton(e) {
    e.preventDefault();
    e.persist();
    let form = this.refs.form,
        formData = new FormData(form),
        responseHandler = (data, error, xhr)=>{
          if (xhr.status == 200 || xhr.status == 201) {
            this.props.delegate.formDidUpdate(e);
            this.unmount();
          } else if (xhr.status == 400) {
            this.setState({errors: xhr.responseJSON.errors});
          } else {
          }
        };
        
    if (this.props.item) {
      SMRoomUnavailabilityResource.updateUnavailability(this.props.item.id, formData, {}, responseHandler);
    } else {
      SMRoomUnavailabilityResource.postUnavailability(formData, {}, responseHandler);
    }
  }
  
  handleClickDeleteButton(e) {
    e.preventDefault();
    e.persist();
    let form = this.refs.form,
        responseHandler = (data, error, xhr)=>{
          if (xhr.status == 204) {
            this.props.delegate.formDidUpdate(e);
            this.unmount();
          } else {
          }
        };
        
    SMRoomUnavailabilityResource.deleteUnavailability(this.props.item.id, {
        room_id: this.props.room.id,
    }, responseHandler);
  }
  
  render() {
    let repeatWdays = [false,false,false,false,false,false,false],
        startDay = null,
        endDay = null,
        startHour = null,
        endHour = null,
        deleteButton,
        hiddenFields = [];
        
    if (this.props.selectedDate) {
      startDay = I18n.l('date.ymd_simple', this.props.selectedDate);
      endDay = I18n.l('date.ymd_simple', this.props.selectedDate);
    }
    
    if (this.props.plan == this.props.room) {
      hiddenFields.push(<input key={'room-'+this.props.room.id} type='hidden' name='room_id' defaultValue={this.props.room.id} />);
    } else {
      hiddenFields.push(<input key={'plan-'+this.props.plan.id} type='hidden' name='plan_id' defaultValue={this.props.plan.id} />);
    }
        
    if (this.props.item) {
      hiddenFields.push(<input key={'room_unavailability-'+this.props.item.id} type='hidden' name='id' defaultValue={this.props.item.id} />);
      <input type='hidden' name='room_id' defaultValue={this.props.room.id} />;
      deleteButton = <a href="#" className="fr link-hover-border mt10" onClick={this.handleClickDeleteButton.bind(this)}>削除する</a>;
    
      let startWeekDay = this.props.item.start_weekday.split(',');
      for (let i=0; i < I18n.t('date.abbr_day_names').length; i++) {
        repeatWdays[i] = false;
        for (let j=0; j < startWeekDay.length; j++) {
          if (parseInt(startWeekDay[j]) == i) {
            repeatWdays[i] = true;
            break;
          }
        }
      }
          
      if (this.props.item.is_all_day) {
        startDay = I18n.l('date.ymd_simple', this.props.item.started_on);
        endDay = new Date(this.props.item.ended_on);
        endDay = I18n.l('date.ymd_simple', endDay.setDate(endDay.getDate()));
      } else {
        startDay = I18n.l('date.ymd_simple', this.props.item.started_at);
        endDay = new Date(this.props.item.ended_at);
        if (endDay.getHours() === 0) endDay.setDate(endDay.getDate() - 1);
        endDay = I18n.l('date.ymd_simple', endDay);
        startHour = new Date(this.props.item.started_at).getHours();
        endHour = new Date(this.props.item.ended_at).getHours();
      }
    }
    
    return(
      <div className="baloon special-price__baloon js-calendar-baloon">
        <div className="baloon-inner special-price__baloon-inner">
          <h3 className="dashboard-title2 mb20">利用可否を設定する</h3>

          <form ref="form">
            {hiddenFields}
            <div className="special-price__box">
              <input type="text" className="js-datepicker w110 mr5" name="start_day" defaultValue={startDay} />
              〜
              <input type="text" className="js-datepicker w110 ml5" name="end_day" defaultValue={endDay} />
            </div>

            <div className="special-price__box">
              <input type="radio" value="1" id="form-radio01__01" name="frequency" defaultChecked={this.props.item ? this.props.item.frequency == 1 : true} />
              <label htmlFor="form-radio01__01" className="form-radio__s">毎日</label>
              <input type="radio" value="2" id="form-radio01__02" name="frequency" defaultChecked={this.props.item ? this.props.item.frequency == 2 : false} />
              <label htmlFor="form-radio01__02" className="form-radio__s">特定の日</label>

              <input type='hidden' name='start_weekday[]' defaultValue='' />
              <input type="checkbox" value="0" id="form-checkbox01__01" name="start_weekday[]" defaultChecked={repeatWdays[0]}  />
              <label htmlFor="form-checkbox01__01" className="form-checkbox__s w35">日</label>
              <input type="checkbox" value="1" id="form-checkbox01__02" name="start_weekday[]" defaultChecked={repeatWdays[1]} />
              <label htmlFor="form-checkbox01__02" className="form-checkbox__s w35">月</label>
              <input type="checkbox" value="2" id="form-checkbox01__03" name="start_weekday[]" defaultChecked={repeatWdays[2]} />
              <label htmlFor="form-checkbox01__03" className="form-checkbox__s w35">火</label>
              <input type="checkbox" value="3" id="form-checkbox01__04" name="start_weekday[]" defaultChecked={repeatWdays[3]} />
              <label htmlFor="form-checkbox01__04" className="form-checkbox__s w35">水</label>
              <input type="checkbox" value="4" id="form-checkbox01__05" name="start_weekday[]" defaultChecked={repeatWdays[4]} />
              <label htmlFor="form-checkbox01__05" className="form-checkbox__s w35">木</label>
              <input type="checkbox" value="5" id="form-checkbox01__06" name="start_weekday[]" defaultChecked={repeatWdays[5]} />
              <label htmlFor="form-checkbox01__06" className="form-checkbox__s w35">金</label>
              <input type="checkbox" value="6" id="form-checkbox01__07" name="start_weekday[]" defaultChecked={repeatWdays[6]} />
              <label htmlFor="form-checkbox01__07" className="form-checkbox__s w35">土</label>
              <input type='hidden' name='is_holiday' defaultValue='0' />
              <input type="checkbox" value="1" id="form-checkbox01__08" name="is_holiday" defaultChecked={this.props.item ? this.props.item.is_holiday : false} />
              <label htmlFor="form-checkbox01__08" className="form-checkbox__s">祝日</label>
            </div>

            <div className="special-price__box">
              <input type="radio" value="1" id="form-radio02__01" name="is_all_day" defaultChecked={this.props.item ? !!this.props.item.is_all_day : true} />
              <label htmlFor="form-radio02__01" className="form-radio__s">終日</label>
              <input type="radio" value="0" id="form-radio02__02" name="is_all_day" defaultChecked={this.props.item ? !this.props.item.is_all_day : false} />
              <label htmlFor="form-radio02__02" className="form-radio__s">特定の時間</label>
              <span className="message-disabled">
                <input type="text" className="w40" name="start_hour" placeholder="9" defaultValue={startHour} /> :00
                  <span className="ml5 mr5">〜</span>
                <input type="text" className="w40" name="end_hour" placeholder="20" defaultValue={endHour} /> :00
              </span>
            </div>
            
            <div className="special-price__box">   
              <input type="radio" value="0" id="form-radio03__01" name="is_blocked" defaultChecked={this.props.item ? !this.props.item.is_blocked : true} /> 
              <label htmlFor="form-radio03__01" className="form-radio__s">利用可能</label> 
              <input type="radio" value="1" id="form-radio03__02" name="is_blocked" defaultChecked={this.props.item ? !!this.props.item.is_blocked : false} />
              <label htmlFor="form-radio03__02" className="form-radio__s">利用不可</label>
            </div>

            <a href="#" className="button button-blue pt10 pb10 w110" onClick={this.handleClickSaveButton.bind(this)}>保存する</a>
            {deleteButton}
          </form>

        </div>
      </div>
    );
  }
}

export default SMORoomUnavailabilityCalendarBaloon;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/calendar/SMORoomUnavailabilityCalendarBaloon.jsx